import { Link } from "react-router-dom";
import { useNews } from "@/hooks/useNews";

export const NewsTicker = () => {
  const { items } = useNews(10);
  if (!items.length) return null;
  const loop = [...items, ...items];
  return (
    <div data-testid="news-ticker" className="border-b border-slate-800 bg-[#080B10] flex items-center overflow-hidden">
      <Link to="/latest-news" data-testid="news-ticker-label" className="shrink-0 z-10 flex items-center gap-2 bg-[#0052FF] px-3 sm:px-4 py-2 font-mono text-[10px] sm:text-[11px] font-semibold uppercase tracking-widest text-white">
        <span className="live-dot h-1.5 w-1.5 rounded-full bg-white" /> Breaking
      </Link>
      <div className="ticker-mask relative flex-1 overflow-hidden">
        <div className="ticker-track flex w-max gap-10 py-2 pl-6">
          {loop.map((n, i) => (
            <Link key={`${n.key}-${i}`} to={`/news/${n.slug}`} tabIndex={i >= items.length ? -1 : undefined}
              data-testid={i < items.length ? `ticker-item-${i}` : undefined} aria-hidden={i >= items.length}
              className="flex items-center gap-2 whitespace-nowrap text-xs sm:text-sm text-slate-300 hover:text-white transition-colors">
              <span className="font-mono text-[10px] uppercase tracking-wider text-sky-400">{n.source}</span>
              {n.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
